// 🪄 Klick-Handler für personalisierte Produkte (Trade-kompatibel)
document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', async (e) => {
    const button = e.target.closest('.btn-add-personalized');
    if (!button) return;
    e.preventDefault();

    const variantId = button.dataset.variantId;
   const input = button
  .closest('.variant-item, .quick-order-extra, .variant-item__info')
  ?.querySelector('input[name="properties[Wunschname]"]');

    const wunschname = input ? input.value.trim() : '';

    if (!wunschname) {
      alert('Bitte gib zuerst einen Wunschnamen ein.');
      return;
    }

    const formData = {
      id: variantId,
      quantity: 1,
      properties: { Wunschname: wunschname },
    };

    try {
      // Produkt hinzufügen
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) throw new Error('Fehler beim Hinzufügen');
      const data = await response.json();
      console.log('✅ Erfolgreich hinzugefügt:', data);

      // 🧮 Warenkorb-Bubble neu laden
      fetch('/?section_id=cart-icon-bubble')
        .then((res) => res.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newBubble = doc.querySelector('#shopify-section-cart-icon-bubble');
          const currentBubble = document.querySelector('#shopify-section-cart-icon-bubble');
          if (newBubble && currentBubble) {
            currentBubble.innerHTML = newBubble.innerHTML;
          }

          // 🔔 Trade-kompatible Events feuern
          document.dispatchEvent(new CustomEvent('cart:updated'));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch((err) => console.error('Fehler beim Laden der cart-icon-bubble:', err));

      // 🛍 Drawer (Ajax-Warenkorb) neu laden und öffnen
      const cartDrawer = document.querySelector('cart-drawer, .cart-drawer');
      if (cartDrawer) {
        fetch('/?section_id=cart-drawer')
          .then((res) => res.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const newDrawer = doc.querySelector('.drawer__inner');
            const currentDrawer = document.querySelector('.drawer__inner');
            if (newDrawer && currentDrawer) {
              currentDrawer.innerHTML = newDrawer.innerHTML;
              cartDrawer.classList.add('is-open');
            }
          })
          .catch((err) => console.error('Fehler beim Aktualisieren des Drawers:', err));
      }

      // 🔄 Trade-spezifische Aktualisierung (Bubble sofort neu laden)
      if (window.Shopify && window.Shopify.theme && typeof window.Shopify.theme.cart === 'object') {
        try {
          window.Shopify.theme.cart.getCart().then((cart) => {
            // Aktualisiert die Bubble im Header
            const bubble = document.querySelector('[data-cart-count]');
            if (bubble) bubble.textContent = cart.item_count;

            // Event für Trade-Themes, falls andere Module auf Änderungen hören
            document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: cart }));
          });
        } catch (err) {
          console.warn('Trade-Warenkorb konnte nicht aktualisiert werden:', err);
        }
      }

      // 🧩 Optional: Publish-Event für Trade Theme (sofortige Aktualisierung)
      try {
        publish &&
          publish(PUB_SUB_EVENTS?.cartUpdate || 'cartUpdate', {
            source: 'quick-order-list',
            cartData: await fetch('/cart.js').then((r) => r.json()),
          });
      } catch (err) {
        console.warn('Publish Event fehlgeschlagen (nicht kritisch):', err);
      }

      alert(`„${data.product_title}“ mit Wunschname „${wunschname}“ wurde in den Warenkorb gelegt!`);
    } catch (err) {
      console.error('❌ Fehler beim Hinzufügen:', err);
      alert('Leider gab es ein Problem beim Hinzufügen zum Warenkorb.');
    }
  });
});
// === PLUS / MINUS Steuerung für normale (nicht personalisierte) Produkte ===
document.addEventListener('click', async (event) => {
  const button = event.target.closest('.quantity__button');
  if (!button) return;

  const variantId = button.dataset.variantId;
  const input = document.querySelector(`.quantity__input[data-variant-id="${variantId}"]`);
  if (!input) return;

  let quantity = parseInt(input.value) || 0;
  const action = button.getAttribute('name');

  if (action === 'plus') quantity++;
  if (action === 'minus' && quantity > 0) quantity--;

  input.value = quantity;

  try {
    // 🛒 AJAX Update im Shopify Warenkorb
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: { [variantId]: quantity } }),
    });

    const cart = await response.json();
    console.log('🛍 Warenkorb aktualisiert:', cart);

    // 🔔 Trade-kompatible Events triggern
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));

    // 🧮 Bubble sofort neu laden
    fetch('/?section_id=cart-icon-bubble')
      .then(res => res.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newBubble = doc.querySelector('#shopify-section-cart-icon-bubble');
        const currentBubble = document.querySelector('#shopify-section-cart-icon-bubble');
        if (newBubble && currentBubble) {
          currentBubble.innerHTML = newBubble.innerHTML;
        }
      });

  } catch (error) {
    console.error('❌ Fehler beim Warenkorb-Update:', error);
  }
});
